import debounce from 'lodash-es/debounce';
import { useCallback, useMemo } from 'react';

export function useDebounceSearch(
  fnToDebounce: (searchInput: string) => void,
  minSearchCharacters: number,
) {
  const searchFn = useMemo(() => debounce(fnToDebounce, 500), [fnToDebounce]);

  const fn = useCallback(
    (searchInput: string) => {
      if (searchInput && searchInput.length >= minSearchCharacters) {
        searchFn(searchInput);
      } else {
        searchFn.cancel();
      }
    },
    [minSearchCharacters, searchFn],
  );

  return fn;
}
